<div #mapContainer class="maplibre-container maplibre-outlets"></div>
